import dynamic from 'next/dynamic'

import { useRouter } from 'next/router'

import { useCallback, useState } from 'react'

import ButtonBlue from '../../../../components/ui/button/_color/_blue'

import { useAppSelector } from '../../../../store/hooks'

import { LoginStatuses, selectedAuthStatus } from '../../../../store/reducers/users'

import styles from './styles.module.scss'

import EarnHoldingImage from './images/earn-holding.png'
import EasyAssetImage from './images/easy-asset.png'
import LendBorrowSwapImage from './images/lend-borrow-swap.png'
import StoreBitcoinImage from './images/store-bitcoin.png'

import BlueWaveIcon from './icons/blue-wave.svg'
import GreenLineIcon from './icons/green-line.svg'
import { useTranslation } from 'utils/use-translation'

const LoginForm = dynamic(() => import('../../../../components/ui/header/components/popup-login-form'), { ssr: false })

const POPUP_TYPE_LOANS = 'loans'

export default function CoinWalletCryptoPlatform({ pageCurrency }) {
  const { t, replacePlaceholders, locale } = useTranslation()
  const [isOpenLoginBlock, setIsOpenLoginBlock] = useState(false)

  const placeholders = {
    name: pageCurrency.name,
    ticker: pageCurrency.ticker
  }

  const authStatus = useAppSelector(selectedAuthStatus)
  const router = useRouter()

  const handleClosePopup = useCallback(() => {
    setIsOpenLoginBlock(false)
  }, [])

  const goToWallets = async () => {
    if (authStatus === LoginStatuses.LOGIN) {
      await router.push({
        pathname: '/account/wallets',
      })
    } else {
      setIsOpenLoginBlock(true)
    }
  }

  return (
    <section className={styles.cryptoPlatform}>
      <h2>{t('platform_for_everyone')}</h2>
      <p className={styles.cryptoPlatform__subtitle}>{t('simple_safe_solution_all_needs')}.</p>

      <div className={styles.benefit}>
        <div className={styles.benefit__content}>
          <h3>{t('store')} {pageCurrency.name} {t('safely')}</h3>
          <p>{replacePlaceholders(t('keep_safe'), placeholders)}</p>
          <ButtonBlue onClick={goToWallets} className={styles.btn} bordered>{t('get_started')}</ButtonBlue>
        </div>
        <img src={StoreBitcoinImage} alt="store currency name safety image" />
      </div>

      <div className={styles.benefit}>
        <img
          src={
            pageCurrency.earnWhileHoldingImage && pageCurrency.earnWhileHoldingImage.data
              ? `https://cms.coinrabbit.io${pageCurrency.earnWhileHoldingImage.data.attributes.url}`
              : EarnHoldingImage
          }
          alt="earn while holding image"
        />
        <div className={styles.benefit__content}>
          <div className={styles.benefit__content__header}>
            <h3>{t('crypto_rewards')}</h3>
            <img className={styles.blueWave} src={BlueWaveIcon} alt="blue wave icon" />
          </div>
          <p>{t('earn_up_answer')}</p>
          <ButtonBlue onClick={goToWallets} className={styles.btn} bordered>{t('access_all_features')}</ButtonBlue>
        </div>
      </div>

      <div className={styles.benefit}>
        <div className={styles.benefit__content}>
          <h3>{t('more_wallet_options')}</h3>
          <p>
            {replacePlaceholders(t('convert_crypto_seamlessly'), placeholders)}
          </p>
          <ButtonBlue onClick={goToWallets} className={styles.btn} bordered>{t('create_account')}</ButtonBlue>
        </div>
        <img src={LendBorrowSwapImage} alt="lend, borrow, swap and more image" />
      </div>

      <div className={styles.benefit}>
        <img src={EasyAssetImage} alt="easy asset management image" />
        <div className={styles.benefit__content}>
          <div className={styles.benefit__content__header}>
            <h3>{t('simple_management')}</h3>
            <img data-lang={locale} className={styles.greenLine} src={GreenLineIcon} alt="green line icon" />
          </div>
          <p>
            {replacePlaceholders(t('take_control'), placeholders)}
          </p>
          <ButtonBlue onClick={goToWallets} className={styles.btn} bordered>{t('deposit_crypto')}</ButtonBlue>
        </div>
      </div>
      {isOpenLoginBlock && <LoginForm isWallet={false} onCloseForm={handleClosePopup} type={POPUP_TYPE_LOANS} />}
    </section>
  )
}
